<template>
    <div class="main">
        <NavBar class="nav-bar" :reloadPage="reloadPage"/>
        <div class="page-content">
            <Gallery class="gallery" ref="mainGallery" :getWindowContent="getWindowContent" :currentWindow="currentWindow"/>
            <Discover :isVisible="currentWindow === 0" :getPressedSong="getPressedSong" :getLatestSongs="getLatestSongs" :songPlaying="song"/>
            <TheNeed :isVisible="currentWindow === 1" :onGoToSubmitTrack="onGoToSubmitTrack"/>
            <OurMission :isVisible="currentWindow === 2"/>
            <Uploader :isVisible="currentWindow === 3"/>
            <CollabLabHome :isVisible="currentWindow === 4" :onReceiveDemo="onReceiveDemo" :currentSong="song"/>
        </div>
        <v-footer fixed padless v-if="songSelected">
            <MusicPlayerFooter
                class="music-player"
                :song="song"
                :songList="latestSongs"
                :songIndex="songIndex"
                :onClosePlayer="onClosePlayer"
                :returnSongFromPlayer="returnSongFromPlayer"
                :songDownloadable="songDownloadable"
            />
        </v-footer>
    </div>
</template>
<script>
    export default {
        components: {
            Gallery: () => import('../components/Gallery.vue'),
            NavBar: () => import('../components/NavBar.vue'),
            Discover: () => import('../components/Discover.vue'),
            Uploader: () => import('../components/Uploader.vue'),
            MusicPlayerFooter: () => import('../components/MusicPlayerFooter.vue'),
            CollabLabHome: () => import('../components/CollabLabHome'),
            TheNeed: () => import('../components/TheNeed'),
            OurMission: () => import ('../components/OurMission'),
        },
        data() {
            return {
                currentWindow: 0,
                songSelected: false,
                song: {},
                latestSongs: [],
                songIndex: null,
                songDownloadable: false
            }
        },
        methods: {
            getWindowContent(index = 0) {
                this.currentWindow = index;
            },
            getLatestSongs(latestSongs) {
                this.latestSongs = latestSongs;
            },
            getPressedSong(song, index) {
                this.songSelected = true;
                this.song = song;
                this.songIndex = index;
                this.songDownloadable = false;
            },
            reloadPage() {
                this.currentWindow = 0;
            },
            onGoToSubmitTrack() {
                this.currentWindow = 3;
                window.scrollTo(0, 0);
            },
            onClosePlayer() {
                this.songSelected = false;
            },
            returnSongFromPlayer(song, index) {
                if (song) {
                    this.song = song;
                    this.songIndex = index;
                } else {
                    this.song = {};
                    this.songIndex = null;
                }
            },
            onReceiveDemo(demo) {
              this.songSelected = true;
              this.songDownloadable = true;
              this.song = demo;
            }
        },
        mounted() {
            this.getWindowContent();
        }
    }

</script>
<style scoped>
    .main {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        background-color: black;
    }
    .nav-bar {
        width: 100%;
    }
    .page-content {
        width: 100%;
    }
    .music-player {
        width: 100%;
    }

</style>